import kohlerCorporateConfig from '../kohlerCorporateConfig';

class CareersSearchService {

    /**
     * @param {{s: string, filter: string}} queryObject
     * @param {Number} offset
     * @param {Number} itemsPerPage
     */
    async getResults(queryObject, offset, itemsPerPage, sortBy) {
        /* Expected format for body */
        // const body = {
        //     query: queryObject.q || '',
        //     filterValues: queryObject.filterValues,
        //     offset: offset,
        //     itemsPerPage: itemsPerPage
        // };
        // console.log(queryObject.filterValues);
        const body = {
            filterValues: queryObject.filterValues,
            offset: offset,
            itemsPerPage: itemsPerPage,
            query: queryObject.q,
            sortBy: sortBy,
            currentPageId: document.getElementById('currentPageId').value
        }

        return fetch(kohlerCorporateConfig.careersSearchEndpointUrl, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {'Content-type': 'application/json; charset=utf-8'},
            body: JSON.stringify(body),
            referrer: "no-referrer",
        })
        .then(response => response.json())
        .catch(error => {console.log(error);return []});
    }

}
export default new CareersSearchService();
